import * as React from "react";
import { useState, useRef, useContext, useEffect } from "react";
import FContext from "./context/Context";
import { useNavigate } from "react-router-dom";
import classes from "./Upload.module.css";
import axios from "axios";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
// import Backdrop from "./Backdrop";
import Modal from "./Modal";

// import pdfjsnpm from 'pdfjs/';

// import logo from "./images/logo.png";

const Upload = () => {
  const base_url = process.env.REACT_APP_BASE_URL;

  const navigate = useNavigate();
  const formCtx = useContext(FContext);

  const stateCode = useRef();

  const [isLoading, setIsLoading] = useState(false);
  const [stateCodeValid, setStateCodeValid] = useState(true);
  const [file1, setFile1] = useState({});
  const [file2, setFile2] = useState({});
  const [file3, setFile3] = useState({});
  const [file4, setFile4] = useState({});
  const [selectedDescription, setSelectedDescription] = useState("");
  const [titleValid, setTitleValid] = useState(true);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [introducer, setIntroducer] = useState("");
  const [meansOfID, setMeansOfID] = useState("");
  const [valid, setValid] = useState(true);
  const [receivedData, setReceivedData] = useState({});
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [error, setError] = useState({});
  const [uploadError, setUploadError] = useState({});
  const [titleList, setTitleList] = useState([]);
  const [docNo, setDocNo] = useState("");
  const title = useRef();
  if (!formCtx.formData.val) {
    console.log("formData is false");
  }
  useEffect(() => {
    setReceivedData(JSON.parse(localStorage.getItem("regPayLoad")));

     axios
      .get("./data/dropdown-options.json")
      .then((res) => {
        console.log(res.data.identity.identity);
        setTitleList(res.data.identity.identity);
      })
      .catch((err) => {
        console.log(err);
      });
    //End use effect hook
  }, []);

  const titleChangeHandler = (event) => {
    const titleValue = title.current.value;
    setMeansOfID(title.current.value);

    const selectedTitle = titleList.find(
      (item) => item.IDENTIFICATION_CD === titleValue
    );

    if (selectedTitle) {
      setSelectedDescription(selectedTitle.IDENTIFICATION_DSC);
    } else {
      setSelectedDescription("");
    }
    if (titleValue === "" || titleValue === "Select Title") {
      setTitleValid(false);
    } else {
      setTitleValid(true);
    }
  };

  // HANDLE FILE CHANGE=========================================================

  // const handleFile1Change = (e) => {
  //   const file = e.target.files[0];
  //   const leader = new FileReader();

  //   leader.addEventListener("load", () => {
  //     setFile1((prev) => {
  //       return {
  //         ...prev,
  //         new: leader.result,
  //       };
  //     });
  //   });

  //   leader.readAsDataURL(file);
  // };

  // const handleFile2Change = (e) => {
  //   const file = e.target.files[0];
  //   const reader = new FileReader();
  //   reader.addEventListener("load", () => {
  //     setFile2((prev) => {
  //       return {
  //         ...prev,
  //         new: reader.result,
  //       };
  //     });
  //   });

  //   reader.readAsDataURL(file);
  // };

  // const handleFile3Change = (e) => {
  //   const file = e.target.files[0];
  //   const reader = new FileReader();
  //   reader.addEventListener("load", () => {
  //     setFile3((prev) => {
  //       return {
  //         ...prev,
  //         new: reader.result,
  //       };
  //     });
  //   });

  //   reader.readAsDataURL(file);
  // };

  // const handleFile4Change = (e) => {
  //   const file = e.target.files[0];
  //   const reader = new FileReader();
  //   reader.addEventListener("load", () => {
  //     setFile4((prev) => {
  //       return {
  //         ...prev,
  //         new: reader.result,
  //       };
  //     });
  //   });

  //   reader.readAsDataURL(file);
  // };


  // END HANDLE FILE CHANGE =============================================================================================

  // const handleBlur = (e) => {

  //   const reg = /^\S+@\S+\.\S+$/;
  //   console.log(e.target.value)
  //   const emailVal = e.target.value;
  //   const EmailIsValid = reg.test(emailVal);
  //   if (!EmailIsValid) {
  //     setValid(false)
  //     console.log(valid)
  //   }
  //   else {
  //     setValid(true)
  //     setRMemail(e.target.value);
  //   }

  // };

  const handleCheckBox = (event) => {
    if (acceptTerms) {
      event.target.value = "";
    }

    setAcceptTerms((prev) => !prev);

    console.log(event.target.value);
  };

  //new handle file change event === J.O
  const handleFileChange = (e, setFile, fileType) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    // Check the file format here
    if (!file.type.startsWith("image/jpeg")) {
      alert("Invalid file format. Only .JPEG and .JPG images are supported");
      e.target.value = null; // Clear the input field
      return;
    }
    if (file && file.size > 100 * 1024) {
      // Check if the file size exceeds 100KB
      alert('File size exceeds 100KB. Please select a smaller file.');
      e.target.value = null; // Clear the input field
      return;
    }

    reader.addEventListener("load", () => {
      setFile((prev) => {
        return {
          ...prev,
          new: reader.result,
        };
      });
    });

    reader.readAsDataURL(file);
  };


  const handleFile1Change = (e) => {
    handleFileChange(e, setFile1, "Means Of ID");
  };

  const handleFile2Change = (e) => {
    handleFileChange(e, setFile2, "Utility Bill");
  };

  const handleFile3Change = (e) => {
    handleFileChange(e, setFile3, "Passport Photograph");
  };

  const handleFile4Change = (e) => {
    handleFileChange(e, setFile4, "Signature");
  };

  // New handle blur function written by Jam, to change introducers name to introducers email
  const handleBlur = (e) => {
    const textValue = e.target.value;

    // For example, check if the text contains at least one character
    if (textValue.trim() === "" || textValue === "") {
      setValid(false);
    } else {
      setValid(true);
      setIntroducer(textValue); // Set the value based on the text input
    }
  };

  const startDateChangeHandler = (date) => {
    setStartDate(date);
    console.log(date);
  };

  const endDateChangeHandler = (date) => {
    setEndDate(date);
    console.log(date);
  };

  const startDateValue = moment(startDate).format("YYYY MM DD");
  const endDateValue = moment(endDate).format("YYYY MM DD");

  const formSubmitHandler = async (event) => {
    event.preventDefault();

    setError(null);

    const uploadInfo = {
      email: receivedData.primary_email_address,
      meansOfID: file1.new,
      utilityBill: file2.new,
      passport: file3.new,
      signature: file4.new,
      startDate: startDateValue,
      endDate: endDateValue,
      introducer: introducer,
      // idType:title
    };

    console.log(uploadInfo);

    // if (stateCodeValue === "") {
    //  // stateCodeChangeHandler();
    //   return;
    // } else {
    setIsLoading(true);
    receivedData.identity_doc_type_cd = meansOfID;
    receivedData.identity_doc_name = selectedDescription;
    receivedData.identity_doc_no = docNo;
    receivedData.identity_doc_issue_date =
      moment(startDate).format("YYYY MM DD");
    receivedData.identity_doc_expiry_date =
      moment(endDate).format("YYYY MM DD");

    axios
      .post(`${base_url}/turbo/create-turbo-member`, receivedData)
      // .post("http://10.10.10.46:8321/nsl/create-nsl-member", receivedData)
      .then((res) => {
        console.log(res.data);
        uploadInfo.reference = res.data.value.result[0].reference.CustomerID;
        axios
          .post(`${base_url}/turbo/upload-docs`, uploadInfo)
          .then((res) => {
            console.log(res.data);
            setIsLoading(false);
            swal({
              title: "Submitted",
              text: "Form submitted successfully",
              icon: "success",
              button: "Ok",
            }).then((value) => {
              if (value === true) {
                navigate("/fund-account", { replace: true });
              } else {
                navigate("/", { replace: true });
              }
            });
          })
          .catch((err) => {
            console.log(err.message);
            setUploadError(err.message);
            alert("ooops! Something went wrong");
            setIsLoading(false);
          });
      })
      .catch((err) => {
        console.log(err.response.data.error);
        setError(err.message);
        alert(err.response.data.error);
        setIsLoading(false);
      });
    // }
  };

  return (
    <div>
      <div
        className={`${classes.container} form_wrapper`}
        style={{ paddingTop: "25px" }}
      >
        <form className={classes.form__sect} onSubmit={formSubmitHandler}>

          <div className="row">
            <div className="col-md-6">
              <div
                className={`input_field select_option ${classes.account__details
                  } ${!titleValid ? classes.not_valid : ""}`}
              >
                {/* <span><i aria-hidden="true" className="fa fa-envelope"></i></span> */}
                <select
                  ref={title}
                  onChange={titleChangeHandler}
                  onBlur={titleChangeHandler}
                >
                  <option selected>Select Means Of ID</option>
                  {titleList.map((item) => {
                    return (
                      <option
                        key={item.IDENTIFICATION_CD}
                        value={item.IDENTIFICATION_CD}
                      >
                        {item.IDENTIFICATION_DSC}
                      </option>
                    );
                  })}
                </select>
                <div className="select_arrow"></div>
                {!titleValid && (
                  <p style={{ float: "left" }} className="errorInvalid">
                    please select a means of ID
                  </p>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="input_field">
                <span style={{ height: "35px" }}>
                  <i aria-hidden="true" className="fa fa-envelope">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-link" viewBox="0 0 16 16">
                      <path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9c-.086 0-.17.01-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z" />
                      <path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4.02 4.02 0 0 1-.82 1H12a3 3 0 1 0 0-6H9z" />
                    </svg>
                  </i>
                </span>
                <input
                  type="text"
                  name="text"
                  placeholder="Introducer's Name"
                  onChange={handleBlur}
                  onBlur={handleBlur}
                  className={valid ? "" : "invalid"}
                  required
                />
                <p style={{ fontSize: "10px", marginBottom: "0" }}>Please enter <b>none</b> if no introducer</p>
                {!valid && (
                  <small style={{ color: "red", marginTop: "-10px" }}>
                    Invalid input
                  </small>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className={`${classes.input_field} col-md-6`}>
              <label htmlFor="file">Valid Means Of ID</label> <br />
              <input
                type="file"
                name="file"
                id="file"
                className={classes.file_select}
                onChange={handleFile2Change}
                required
              />
              <p className={classes.file__message}>
                file should be in jpeg or jpg format (Max File Size 100kb)
              </p>
            </div>

            <div className={`${classes.input_field} col-md-6`}>
              <label for="file">Utility Bill</label> <br />
              <input
                type="file"
                name="file"
                id="file"
                className={classes.file_select}
                onChange={handleFile1Change}
                required
              />
              <p className={classes.file__message}>
                file should be in jpeg or jpg format (Max File Size 100kb)
              </p>
            </div>
          </div>
          <div className="row">
            <div className={`${classes.input_field} col-md-6`}>
              <label htmlFor="file">Passport Photograph</label> <br />
              <input
                type="file"
                name="file"
                id="file"
                className={classes.file_select}
                onChange={handleFile3Change}
                required
              />
              <p className={classes.file__message}>
                file should be in jpeg or jpg format (Max File Size 100kb)
              </p>
            </div>

            <div className={`${classes.input_field} col-md-6`}>
              <label for="file">Signature</label> <br />
              <input
                type="file"
                name="file"
                id="file"
                className={classes.file_select}
                onChange={handleFile4Change}
                required
              />
              <p className={classes.file__message}>
                file should be in jpeg or jpg format (Max File Size 100kb)
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div>
                <label for="date">Issuance Date</label>
                <div className={`input_field `}>
                  <DatePicker
                    selected={startDate}
                    onChange={startDateChangeHandler}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              {" "}
              <div>
                <label for="date">Expiry Date</label>
                <div className={`input_field `}>
                  <DatePicker
                    selected={endDate}
                    onChange={endDateChangeHandler}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4" style={{ marginTop: "-6px" }}>
              <label htmlFor="docNo">Document Number</label>
              <input
                type="text"
                name="docNo"
                id="docNo"
                placeholder="Document Number"
                className={classes.file_select}
                onChange={(e) => {
                  e.preventDefault();
                  const docs = e.target.value;
                  setDocNo(docs);
                }}
                required
              />
            </div>
          </div>
          <div>
            <div className={`input_field secondary_email`}>
              <span>
                <i aria-hidden="true" className="fa fa-envelope"></i>
              </span>
              <input
                type="email"
                placeholder="Email"
                value={formCtx.formData}
                disabled
              />
            </div>
            {/* {!emailValid && <p className={classes.invalid}>invalid email</p>} */}
          </div>
          <hr />
          {/* <p className="upload__text">Upload Supporting Documents</p> */}

          {/* <div className="upload_infor">
            <div className={"emailinfo"}>
              <label for="date">
              Start Date
              </label>
              <div className={`input_field date__code`}> 
                <DatePicker
                    selected={startDate}
                    onChange={startDateChangeHandler}
                    className={classes.date__picker}
                  />
              </div>
            </div>
            <div className={"emailinfo"}>
            <label for="date">
              End Date
              </label>
              <div className={`input_field date__code`}>
                <DatePicker
                      selected={endDate}
                      onChange={endDateChangeHandler}
                      className={classes.date__picker}
                    />
              </div>
            </div>
          </div> */}
          {error && <p>{error.text}</p>}

          <div className={`input_field checkbox_option`}>
            <input
              type="checkbox"
              onChange={handleCheckBox}
              id="cb1"
              checked={acceptTerms}
              value="I accept the terms and Norrenberger Limited"
            />
            <label htmlFor="cb1">
              I accept the <a href="https://norrenberger.com/wp-content/uploads/2022/02/Terms-and-Conditions.pdf" target="blank" style={{ textDecoration: "none", color: "#f15a29" }}>
                terms and conditions </a>
              of Norrenberger Securities Limited
            </label>
          </div>
          <div className={classes.submit_sect}>
            <input
              disabled={!acceptTerms}
              style={{ cursor: "pointer" }}
              className="button"
              type="submit"
              value="Next"
            />
          </div>
        </form>
      </div>
      {/* {isLoading && <Backdrop />} */}
      {isLoading && <Modal />}
    </div>
  );
};

export default Upload;